import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import useAxios from '../../api/useAxios';
import { API_ENDPOINTS } from '../../api/endpoints';
import { useAuth } from '../../authContext/useAuth';
import { keyframes } from '@mui/system';
import useApiError from '../../api/useApiError';
import AlertToast from './Alert';

const marquee = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const DisplayBanner = () => {
    const { user } = useAuth();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [toast, setToast] = useState({ open: false, message: '', type: 'error' });

    const {
        data: bannerDataShow,
        error: bannerDataShowError,
        loading: bannerDataShowLoading,
        fetchData: fetchbannerDataShowData,
    } = useAxios<any>(`${API_ENDPOINTS.users.USER_SHOW_BANNER}`, "POST");

    const {
        data: bannerDataCross,
        error: bannerDataCrossError,
        loading: bannerDataCrossLoading,
        fetchData: fetchbannerDataCrossData,
    } = useApiError<any>(`${API_ENDPOINTS.users.USER_CROSS_BANNER}`, "POST");

    useEffect(() => {
        if (user?.id && user?.authorities !== 'ROLE_SUPER_ADMIN') {
            fetchbannerDataShowData({
                userId: user?.id
            });
        }
    }, [user?.id]);

    useEffect(() => {
        if (!bannerDataShow?.data?.length) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % bannerDataShow.data.length);
        }, 15000);

        return () => clearInterval(interval);
    }, [bannerDataShow?.data]);

    if (user?.authorities === 'ROLE_SUPER_ADMIN' || !bannerDataShow?.data?.length) {
        return null;
    }

    const banner = bannerDataShow.data[currentIndex];

    const handelRemoveBanner = async () => {
        const currentBanner = bannerDataShow.data[currentIndex];
        const payloads = {
            bannerId: currentBanner.bannerId,
            userId: user?.id
        }
        try {
            const response = await fetchbannerDataCrossData(payloads);
            if (response?.status === 200) {
                setToast({ open: true, message: response.message, type: 'success' });
            } else if (bannerDataCrossError) {
                setToast({ open: true, message: bannerDataCrossError, type: 'error' });
            }
            if (user?.id && user?.authorities !== 'ROLE_SUPER_ADMIN') {
                fetchbannerDataShowData({
                    userId: user?.id
                });
            }
        } catch {
            setToast({ open: true, message: `Error to remove this banner`, type: 'error' });
        }
    }

    // useEffect(() => {
    //     if(bannerDataCrossError) {
    //         setToast({ open: true, message: bannerDataCrossError, type: 'error' });
    //     }
    // }, [bannerDataCrossError])

    return (
        <>
            <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden', height: '50px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        width: `${bannerDataShow.data.length * 100}%`,
                        transform: `translateX(-${currentIndex * (100 / bannerDataShow.data.length)}%)`,
                        transition: 'transform 0.5s ease-in-out',
                        height: '50px',
                    }}
                >
                    {bannerDataShow.data.map((banner: any, index: number) => (
                        <Box
                            key={index}
                            sx={{
                                backgroundColor: banner.bgColor,
                                color: banner.textColor,
                                padding: '0 4rem',
                                display: 'flex',
                                alignItems: 'center',
                                height: '50px',
                                whiteSpace: 'nowrap',
                                width: `${100 / bannerDataShow.data.length}%`,
                                flexShrink: 0,
                                overflow: 'hidden',
                                position: 'relative',
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    display: 'inline-block',
                                    paddingLeft: '100%',
                                    animation: index === currentIndex ? `${marquee} 20s linear infinite` : 'none',
                                }}
                            >
                                {banner.message}
                            </Box>
                        </Box>
                    ))}
                </Box>

                <IconButton
                    size="small"
                    onClick={handelRemoveBanner}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        zIndex: 1,
                        backgroundColor: theme?.palette?.primary?.main,
                        color: theme?.palette?.text?.primary,
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 0,
                        '&:hover': {
                            backgroundColor: theme?.palette?.primary?.main,
                            color: theme?.palette?.text?.primary,
                            cursor: 'pointer',
                        },
                    })}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
            <AlertToast
                open={toast.open}
                message={toast.message}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                type={toast.type as any}
            />
        </>
    )
}

export default DisplayBanner